import { productFruits } from 'product-fruits'

export const init = ({
  key,
  language,
  user
}: {
  key: string | undefined
  language: string
  user?: { email?: string; name: string; email_verified?: boolean }
}) => {
  if (!key || !user) return
  productFruits.init(key, language, {
    email: user.email,
    username: user.email ?? user.name,
    firstname: user.name,
    props: { email_verified: user.email_verified ?? false }
  })
}
